/* The rules behind /dashboard/profile.
 *
 * TRANSCRIBED from components/admin/Dashboard/profile/UserProfileForm.jsx.
 * Pure functions, so each rule can be checked without a store or a network.
 */

import {
  DESIGNATION_MAX_LENGTH,
  validateDesignation,
} from "../../../../utils/designation";

export { DESIGNATION_MAX_LENGTH };

/* Transcribed: the stored numbers are "<dial code>|<number>", and the form
   holds only the number half. A record saved before that format existed has no
   separator, so the whole value is the number. */
export const splitStoredNumber = (stored) => {
  const raw = String(stored ?? "");
  if (!raw) return { code: "", number: "" };
  const at = raw.indexOf("|");
  if (at === -1) return { code: "", number: raw };
  return { code: raw.slice(0, at), number: raw.slice(at + 1) };
};

export const numberPartOf = (stored) => splitStoredNumber(stored).number;

/* What the form starts with, from the session user. */
export const initialProfileValues = (userInfo) => ({
  name: userInfo?.name || "",
  designation: userInfo?.individual?.[0]?.designation || "",
  employer_company_name: userInfo?.individual?.[0]?.employer_company_name || "",
  mobile: numberPartOf(userInfo?.mobile_number),
  alternateMobile: numberPartOf(userInfo?.alternate_number),
});

/* Transcribed validation, in the live ORDER — the first failure is the only one reported, because the live handler returns on each. */
export const validateProfile = (values) => {
  if (!String(values?.name ?? "").trim()) {
    return { field: "name", message: "Name can't be blank." };
  }
  const designationMessage = validateDesignation(values?.designation);
  if (designationMessage) {
    return { field: "designation", message: designationMessage };
  }
  if (!String(values?.employer_company_name ?? "").trim()) {
    return { field: "employer_company_name", message: "Business Name can't be blank." };
  }
  return null;
};

/* Transcribed body, field for field. The phone values are sent as the form
   holds them — PhoneNumberInput already returns the full number. */
export const profilePayload = (values) => ({
  name: values.name,
  mobile_number: values.mobile,
  alternate_number: values.alternateMobile,
  designation: values.designation,
  employer_company_name: values.employer_company_name,
});

/* Transcribed display rule: out of edit mode every field shows the SAVED value
 * rather than what is being typed, so cancelling is always truthful even before
 * the state is reset.
 */
export const displayValue = ({ isEditMode, draft, saved }) =>
  isEditMode ? draft ?? "" : saved ?? "";

/* Transcribed: the avatar's own actions are `remove` only once there is an
   image to remove. */
export const canRemoveImage = (userInfo) => Boolean(userInfo?.profile_image);
